import { useQuery } from '@apollo/client';
import {
  Box,
  Flex,
  Heading,
  Tabs,
  Tab,
  TabList,
  Skeleton,
} from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  GetUserQueryGQLType,
  GetUserQueryVariablesGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { GET_USER } from 'requests/queries.gql';

const tabIndexes = {
  manage: 0,
  history: 1,
};

export const FundingRequestsViewTemplate = ({
  fundingRequestId,
  children,
  isCreditFacilitySelectDisabled,
  selectedTab,
}: {
  fundingRequestId: string;
  isCreditFacilitySelectDisabled: boolean;
  children: React.ReactChild | React.ReactChild[];
  selectedTab: 'manage' | 'history';
}) => {
  const history = useHistory();
  const { data: userData, loading: userLoading } = useQuery<
    GetUserQueryGQLType,
    GetUserQueryVariablesGQLType
  >(GET_USER);

  if (userLoading || !userData || !userData.user) {
    return (
      <Skeleton height="600px" data-testid="draw-requests-route-loading" />
    );
  }
  const { user } = userData;
  return (
    <>
      <Flex justify="space-between">
        <Heading as="h2">Funding Request</Heading>

        <Box>
          <CreditFacilitySelect
            isDisabled={isCreditFacilitySelectDisabled}
            organizationId={user.organizationId}
          />
        </Box>
      </Flex>
      <Tabs variant="line" index={tabIndexes[selectedTab]} colorScheme="black">
        <TabList>
          <Tab
            onClick={() =>
              history.push(`/funding-requests/${fundingRequestId}`)
            }
          >
            Submit Funding Request
          </Tab>
          <Tab onClick={() => history.push('/funding-requests/history')}>
            History
          </Tab>
        </TabList>
      </Tabs>
      <Box mt="25px" padding="10px">
        {children}
      </Box>
    </>
  );
};
